/**
 * Takes string representing a phone number and removes extra + signs and non-number and non + characters
 * @param phoneNumer - potentially with errors like non-number characters extra + signs etc.
 * @returns normalized phone number string
 * @example "+D410099890+98" => "+41009989098"
 */
export function normalizePhoneNumber(phoneNumer: string): string {
  return phoneNumer.replace(/[^0123456789\s()+-]/gmi, '').replace(/(.{1})(\++)/gmi, '$1')
}
